export default __webpack_public_path__ + "static/media/dhl.6111b871.svg";